import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { map } from 'rxjs';
import { ConfirmarSalida } from '../../shared/confirmar-salida/confirmar-salida';

/** Lo que el guard le pide a una pantalla de formulario. */
export interface ConCambiosSinGuardar {
  hayCambiosSinGuardar(): boolean;
}

/**
 * Avisa antes de abandonar un formulario con cambios sin guardar.
 *
 * Cubre cualquier salida por router: el menú, "Atrás", el botón atrás del
 * navegador o un enlace. Cerrar la pestaña no pasa por acá — de eso se encarga
 * el aviso nativo que registra `seguirCambios()`.
 */
export const cambiosSinGuardarGuard: CanDeactivateFn<ConCambiosSinGuardar> = (componente) => {
  // Sin cambios se sale directo: el modal solo aparece cuando hay algo que perder.
  if (!componente?.hayCambiosSinGuardar?.()) return true;

  const dialog = inject(MatDialog);
  return dialog
    .open(ConfirmarSalida, { width: '460px', maxWidth: '95vw' })
    .afterClosed()
    // Cerrar con Escape o clic fuera devuelve undefined: ante la duda, no se sale.
    .pipe(map((salir) => salir === true));
};
